// ASSET SLOTS — sostituisci questi URL con i tuoi asset caricati su Emergent.
// 1) Logo/illustrazione TONYWIN  2) Immagine di riferimento di Tony Win con la carota (usata nel 3D).
export const ASSETS = {
  // Slot logo IL MAGO TONY (illustrazione brand)
  logo: "https://customer-assets-rejwkqb3.emergentagent.net/job_tonywin-predict/artifacts/d0x0tdzd_Il%20Mago%20Tony_%20Re%20del%20Calcio.png",
  // Slot immagine mascotte Tony (base hero in home)
  tony3d: "https://customer-assets-rejwkqb3.emergentagent.net/job_tonywin-predict/artifacts/d0x0tdzd_Il%20Mago%20Tony_%20Re%20del%20Calcio.png",
  // Tony con la carota in mano (esito "niente di che" nel gioco Trova il premio)
  carrotTony: "https://customer-assets-rejwkqb3.emergentagent.net/job_tonywin-predict/artifacts/30bw0qjx_fa4edf5d-6c5f-41ba-ab8e-7c88bb0eb2a9.png",
};
